const serviceCards = [
  {
    title: "Property Management",
    body:
      "Comprehensive property management for residential and commercial properties, including planning, supervision, maintenance oversight, lease management, rent collection and transparent periodic financial reporting.",
    href: "/property-management-saudi-arabia",
  },
  {
    title: "Real Estate Brokerage",
    body:
      "End-to-end brokerage services for buying, selling and leasing properties, including market analysis, property valuation, negotiations, contract documentation and regulatory compliance to ensure successful transactions.",
    href: "/real-estate-brokerage-saudi-arabia",
  },
  {
    title: "Real Estate Marketing",
    body:
      "Strategic property marketing services including digital campaigns, traditional advertising, professional property presentation, market targeting and enhanced market visibility to achieve maximum exposure and faster sales or leasing.",
    href: "/real-estate-marketing-saudi-arabia",
  },
  {
    title: "Maintenance & Operations",
    body:
      "Reliable maintenance and operations support for properties and facilities, covering preventive maintenance, emergency response, inspections and service coordination to keep assets performing at their best.",
    href: "/property-maintenance-operations-saudi-arabia",
  },
  {
    title: "Property Development",
    body:
      "End-to-end property development services, from feasibility and design coordination to approvals, execution oversight and handover, with a focus on quality delivery and long-term asset value.",
    href: "/property-development-saudi-arabia",
  },
];

const homeTestimonials = {
  clientsFeedbackSubtitle: {
    en: "Feedback",
    ar: "آراء العملاء",
  },
  clientsFeedbackTitle: {
    en: "Clients Feedback",
    ar: "ماذا يقول عملاؤنا",
  },
  testimonials: [
    {
      quote: {
        en: "QTECH helped us take control of a mixed-use property with clear reporting, faster maintenance follow-up, and much better tenant coordination. Their property management team made the asset easier to run month after month.",
        ar: "ساعدتنا QTECH في إدارة عقار متعدد الاستخدامات بشكل أفضل من خلال تقارير واضحة، ومتابعة أسرع لأعمال الصيانة، وتنسيق أكثر كفاءة مع المستأجرين. فريق إدارة الأملاك لديهم جعل تشغيل الأصل أسهل شهرًا بعد شهر.",
      },
      name: {
        en: "Muhammad Mustafa",
        ar: "محمد مصطفى",
      },
      role: {
        en: "Property Owner",
        ar: "مالك عقار",
      },
      image: "/img/feed-back/ar1.jfif",
    },
    {
      quote: {
        en: "We used QTECH for real estate marketing on a residential project in Al Khobar. The listing presentation, campaign management, and buyer follow-up were professional, and the visibility of the project improved noticeably.",
        ar: "تعاوننا مع QTECH في التسويق العقاري لمشروع سكني في الخبر. كان عرض العقار وإدارة الحملات ومتابعة المشترين بمستوى احترافي، وتحسن حضور المشروع في السوق بشكل ملحوظ.",
      },
      name: {
        en: "Muhammad Mahmood",
        ar: "محمد محمود",
      },
      role: {
        en: "Marketing Client",
        ar: "عميل تسويق",
      },
      image: "/img/feed-back/ar2.jfif",
    },
    {
      quote: {
        en: "Their brokerage support was practical and transparent from pricing to negotiation. We felt supported through every step of the transaction, and the documentation process was handled with real care.",
        ar: "كان دعمهم في الوساطة العقارية عمليًا وشفافًا من مرحلة التسعير حتى التفاوض. شعرنا بالدعم في كل خطوة من خطوات الصفقة، وتم التعامل مع إجراءات التوثيق بعناية كبيرة.",
      },
      name: {
        en: "Muhammad Ali",
        ar: "محمد علي",
      },
      role: {
        en: "Buyer Representative",
        ar: "ممثل مشتري",
      },
      image: "/img/feed-back/ar4.jfif",
    },
    {
      quote: {
        en: "QTECH supported our maintenance and operations needs with fast response times and organized technical follow-up. It gave us confidence that the property was being looked after properly on a daily basis.",
        ar: "دعمتنا QTECH في أعمال الصيانة والتشغيل بسرعة استجابة عالية ومتابعة فنية منظمة. هذا منحنا ثقة يومية بأن العقار تتم العناية به بالشكل الصحيح.",
      },
      name: {
        en: "Huda Hoori",
        ar: "هدى حوري",
      },
      role: {
        en: "Facility Supervisor",
        ar: "مشرفة مرافق",
      },
      image: "/img/feed-back/hooda.jpg",
    },
  ],
};

const servicePages = {
  aboutSubtitle: "About Us",
  heading: "Integrated real estate solutions in Saudi Arabia",
  paragraphs: [
    "We are a specialized real estate services company providing integrated solutions in property management, real estate development, brokerage, marketing, and maintenance and operations. We operate in line with the highest professional standards in the Kingdom of Saudi Arabia, using a methodology focused on maximizing asset value, promoting sustainability and delivering reliable results for property owners, investors and clients.",
    "With a commitment to professionalism, transparency and customer satisfaction, we strive to build long-term partnerships and deliver real estate solutions that ensure every client journey is smooth, secure and successful. Our goal is to add real value to every property we manage and to be the trusted partner driving its growth and success.",
  ],
  button: "About Us",
  coreSubtitle: "Our Services",
  coreTitle: "Our Core Services",
  cards: serviceCards,
};

const sidebarLinks = [
  { to: "/property-management-saudi-arabia", label: "Property Management Service" },
  { to: "/real-estate-brokerage-saudi-arabia", label: "Real Estate Brokerage" },
  { to: "/real-estate-marketing-saudi-arabia", label: "Real Estate Marketing" },
  { to: "/property-maintenance-operations-saudi-arabia", label: "Maintenance & Operations" },
  { to: "/property-development-saudi-arabia", label: "Property Development" },
];

const serviceDetails = {
  "property-management": {
    title: {
      en: "Property Management Service Detail",
      ar: "خدمات إدارة الأملاك",
    },
    paragraphs: [
      "We recognize that a property is not just a building; it's an investment asset that requires meticulous care to ensure its sustainability and maximize returns. Quality Technologies offers a comprehensive property management system, relieving you of the burden of daily monitoring and providing you with peace of mind.",
      "Why Choose Our Property Management Services?",
    ],
    highlights: [
      {
        title: "Maximizing Investment Returns",
        body: "By reducing vacancy rates and carefully selecting tenants who support stable occupancy and stronger long-term returns.",
      },
      {
        title: "Preserving Property Value",
        body: "Through preventive and periodic maintenance programs that protect your assets from depreciation and keep the property in strong condition.",
      },
      {
        title: "Absolute Transparency",
        body: "Providing regular financial and technical reports to keep you informed of everything, wherever you are.",
      },
    ],
    moreDetails: [
      "Our property management scope includes occupancy support, vendor coordination, budgeting follow-up and performance tracking so owners have a clearer picture of how each asset is operating over time.",
      "We focus on reducing operational gaps, improving tenant experience and protecting property condition through structured procedures, timely communication and practical day-to-day management decisions.",
    ],
    serviceMatrix: [
      {
        service: "Property Marketing",
        details: "Advertising campaigns and professional promotion to reach the most suitable tenants and shorten vacancy periods.",
      },
      {
        service: "Tenant Selection",
        details: "Careful screening of applicants and suitability review to secure reliable occupancy and reduce operational risk.",
      },
      {
        service: "Maintenance and Operations",
        details: "Full supervision of electricity, plumbing, cleaning and daily service coordination with specialized teams.",
      },
      {
        service: "Contract Management",
        details: "Accurate handling of renewals, tenant notices and contract procedures while preserving rights and organizing follow-up.",
      },
      {
        service: "Financial Reports",
        details: "Providing owners with precise revenue and expense statements to support clear decisions and full visibility.",
      },
    ],
    imageLabel: "Property Management Service",
  },
  brokerage: {
    title: {
      en: "Real Estate Brokerage Service Detail",
      ar: "تفاصيل خدمة الوساطة العقارية",
    },
    paragraphs: [
      "In a fast-paced real estate market, every party needs a trusted partner who safeguards their rights and secures the best possible deal.",
      "We act as your professional real estate broker, serving as the vital link that efficiently and transparently connects the seller's goals with the buyer's or tenant's aspirations.",
      "Our Brokerage Core Values",
    ],
    highlights: [
      {
        title: "Neutrality, Integrity & Protection of Rights",
        body: "We balance interests to ensure complete satisfaction for all parties involved, while documenting every brokerage stage to fully safeguard commissions and the rights of all parties.",
      },
      {
        title: "Regulatory Compliance & Legal Reliability",
        body: "We operate strictly in accordance with the Real Estate General Authority (REGA) regulations to guarantee the legality, reliability, and proper documentation of every transaction.",
      },
      {
        title: "Fast Deal Closing & Local Market Reach",
        body: "Thanks to our extensive database and strong knowledge of regional neighborhoods and price trends, we connect investors, developers, sellers, buyers, and home seekers faster and more effectively.",
      },
    ],
    moreDetails: [
      "What We Offer You as a Real Estate Broker",
      "\"We handle the complex details so you can sign your new contract with absolute peace of mind.\"",
    ],
    serviceMatrix: [
      {
        service: "Market Analysis",
        details: "Pricing the property based on its true market value.",
      },
      {
        service: "Customized Search",
        details: "Finding options that precisely match your aspirations and budget.",
      },
      {
        service: "Effective Marketing",
        details: "Showcasing the property to a wide segment of serious prospects.",
      },
      {
        service: "Inspection & Evaluation",
        details: "Arranging on-site tours and providing a clear picture of the property's condition.",
      },
      {
        service: "Offer Screening",
        details: "Handling negotiations and selecting the most suitable offer for you.",
      },
      {
        service: "Professional Negotiation",
        details: "Striving to secure the best price and contractual terms.",
      },
      {
        service: "Closing the Sale",
        details: "Following up on deed transfer procedures and ensuring the receipt of funds.",
      },
      {
        service: "Legal Support",
        details: "Verifying the validity of title deeds and ensuring the property is free of any liabilities.",
      },
    ],
    imageLabel: "Real Estate Brokerage Service",
  },
  marketing: {
    title: {
      en: "Real Estate Marketing Service Detail",
      ar: "تفاصيل خدمة التسويق العقاري",
    },
    paragraphs: [
      "We employ the latest digital and on-field marketing strategies to ensure your property is presented to the right target audience in the best possible light and within the shortest timeframe.",
      "How Do We Make a Difference in Marketing Your Property?",
    ],
    highlights: [
      {
        title: "Smart Targeting & Vast Network",
        body: "We reach those who are genuinely interested based on location, budget, and specific needs, while leveraging a massive database of active investors and potential clients.",
      },
      {
        title: "Highlighting Key Strengths & Speed of Execution",
        body: "We focus on the unique details that set your property apart from the competition and work to significantly reduce the time your property spends on the market.",
      },
      {
        title: "Legal Professionalism & Effortless Process",
        body: "We ensure the validity and readiness of all procedures and documentation before we begin, while handling exhaustive calls and inquiries on your behalf to save you time and hassle.",
      },
    ],
    moreDetails: [],
    serviceMatrix: [
      {
        service: "Evaluation & Analysis",
        details: "Studying market prices to ensure a competitive and fair valuation for your property.",
      },
      {
        service: "Creative Content",
        details: "Professional photography and videography, paired with compelling marketing descriptions.",
      },
      {
        service: "Digital Exposure",
        details: "Listing the property on major platforms, social media, and targeted Google Ads campaigns.",
      },
      {
        service: "Viewing Management",
        details: "Handling inquiries, screening potential buyers, and organizing professional on-site tours.",
      },
      {
        service: "Negotiation & Closing",
        details: "Managing the negotiation process to secure the best price and following up on deed transfer procedures.",
      },
    ],
    imageLabel: "Real Estate Marketing Service",
  },
  maintenance: {
    title: {
      en: "Property Maintenance & Operations Service Detail",
      ar: "تفاصيل خدمة صيانة الأملاك",
    },
    paragraphs: [
      "We provide integrated engineering and technical solutions for facility management, ensuring your property operates at peak efficiency with the lowest long-term operational costs.",
      "We don’t wait for problems to happen; we anticipate them steps ahead.",
      "Our Vision in Maintenance & Operation",
    ],
    highlights: [
      {
        title: "Rapid Response",
        body: "Emergency teams ready for immediate intervention whenever a sudden breakdown occurs.",
      },
      {
        title: "Standardized Quality",
        body: "Using genuine spare parts and adopting precise engineering standards.",
      },
      {
        title: "Extending Asset Lifespan",
        body: "Keeping the property's vital systems (elevators, HVAC, pumps) in optimal condition.",
      },
    ],
    moreDetails: [],
    serviceMatrix: [
      {
        service: "Electrical Systems",
        details: "Maintenance of distribution boards, lighting, and power wiring to ensure safety and continuity.",
      },
      {
        service: "Plumbing & Insulation",
        details: "Leak detection and repair, maintenance of water tanks, and sewage networks using the latest technologies.",
      },
      {
        service: "HVAC (Heating, Ventilation, & AC)",
        details: "Periodic maintenance of central and split air conditioners to ensure cooling efficiency and air purity.",
      },
      {
        service: "Elevator Maintenance",
        details: "Periodic contracts and continuous safety inspections to guarantee user safety.",
      },
      {
        service: "Cleaning & Sanitation",
        details: "Comprehensive cleaning programs for entrances, corridors, and the property's exterior facades.",
      },
    ],
    imageLabel: "Maintenance & Operations Service",
  },
  development: {
    title: {
      en: "Property Development Service Detail",
      ar: "تفاصيل خدمة التطوير العقاري",
    },
    paragraphs: [
      "We deliver development projects from initial concept and analytical studies all the way to turnkey delivery, focusing on the highest quality standards and optimal spatial utilization.",
      "Our Development Philosophy",
    ],
    highlights: [
      {
        title: "Architectural Innovation & Comprehensive Vision",
        body: "We create modern designs that seamlessly blend aesthetics with practical functionality, while bringing together legal, engineering, and marketing expertise under one roof.",
      },
      {
        title: "Maximizing Land Value & Risk Management",
        body: "We conduct rigorous feasibility studies to secure the highest profitable returns for landowners and investors, supported by precise market-risk analysis before groundbreaking.",
      },
      {
        title: "Sustainability & Strategic Relationships",
        body: "We adopt modern, eco-friendly construction technologies that help projects endure for decades, backed by strong partnerships with financial institutions, engineering consultancies, and major contracting companies.",
      },
    ],
    moreDetails: [],
    serviceMatrix: [
      {
        service: "Feasibility Studies",
        details: "Analyzing the market, studying the area, and determining the highest and best use (residential, commercial, administrative).",
      },
      {
        service: "Design & Licensing",
        details: "Collaborating with elite designers and securing all official permits and approved blueprints.",
      },
      {
        service: "Construction Management",
        details: "Direct supervision of contractors to guarantee execution according to schedules and technical specifications.",
      },
      {
        service: "Finance & Investment",
        details: "Structuring investment partnerships and providing innovative financing solutions for projects.",
      },
      {
        service: "Marketing & Sales",
        details: "Developing exit strategies, whether through full-scale sales or leasing and operations.",
      },
    ],
    imageLabel: "Property Development Service",
  },
};

export function getServicesPageCopy() {
  return servicePages;
}

export function getHomeTestimonialsCopy() {
  return homeTestimonials;
}

export function getSidebarLinks() {
  return sidebarLinks;
}

export function getServiceDetailsCopy(key) {
  return serviceDetails[key] || serviceDetails.marketing;
}
